import type { PriorityPaymentRow } from '@/Network/Types/Responses/PriorityPaymentsResponses'

/** Frente G: onde o plantão acontece — unidade, setor e posição da vaga. */
export interface PriorityPlaceChip {
  key: 'unit' | 'sector' | 'position'
  label: string
  /** Texto completo (o chip trunca no card). */
  title: string
}

/** Célula de texto da Tabela/Lista: sem valor = "—". */
export const formatPlaceCell = (value: string | null | undefined): string =>
  value && value.trim() ? value : '—'

/**
 * Chips do card do Kanban. Sem unidade cai no nome da escala (mesma regra do
 * card de antes); setor e posição só entram quando existem — chip vazio não.
 */
export const priorityPlaceChips = (row: PriorityPaymentRow): PriorityPlaceChip[] => {
  const chips: PriorityPlaceChip[] = []
  if (row.healthUnitName) {
    chips.push({ key: 'unit', label: row.healthUnitName, title: `Unidade: ${row.healthUnitName}` })
  } else if (row.scheduleName) {
    chips.push({ key: 'unit', label: row.scheduleName, title: `Escala: ${row.scheduleName}` })
  }
  if (row.sectorName) {
    chips.push({ key: 'sector', label: row.sectorName, title: `Setor: ${row.sectorName}` })
  }
  if (row.positionName) {
    chips.push({ key: 'position', label: row.positionName, title: `Posição: ${row.positionName}` })
  }
  return chips
}
